    import { geoserver_layers } from "./geoserver_layers";
    import { GEOSERVER_BASE_URL, WMS_URL, getLegendUrl } from "../../utils/GeoServer";

    // Derive Himachal-focused layers by switching the layer id prefix
    export const hp_species_layers = geoserver_layers.map((l) => ({
    ...l,
    })); 
    
    const createCircleWKT3857 = (lng, lat, radiusMeters, points = 64) => {
        const coords = [];
      
        // convert lat/lng to Web Mercator
        const R = 6378137;
        const x0 = (lng * Math.PI * R) / 180;
        const y0 =
          Math.log(Math.tan(Math.PI / 4 + (lat * Math.PI) / 360)) * R;
      
        for (let i = 0; i <= points; i++) {
          const angle = (i * 2 * Math.PI) / points;
          const x = x0 + radiusMeters * Math.cos(angle);
          const y = y0 + radiusMeters * Math.sin(angle);
          coords.push(`${x} ${y}`);
        }
      
        return `POLYGON((${coords.join(",")}))`;
      };
   

export const withRasterClipParams = (
    layers,
    { lng, lat },
    radiusMeters = 4000 // ✅ 4 km
  ) => {
    const circleWKT = createCircleWKT3857(lng, lat, radiusMeters);
  
    return layers.map((l) => ({
      ...l,
      wmsParams: {
        ...(l.wmsParams || {}),
        CLIP: circleWKT,
        _t: Date.now(),
      },
    }));
  };
  
  

 


    export { GEOSERVER_BASE_URL, WMS_URL, getLegendUrl };
